import React, { Component } from 'react';

import BiographyEntry from '../../model/biographyEntry';
import { getCurrentLangCode, getLangData } from '../../services/lang';
import { getAllBiographyEntries } from '../../services/strapiService';
import TimelineEntry from './TimelineEntry';

type BiographyState = {
    biographyEntries: Array<BiographyEntry>;
};

export default class Biography extends Component<{}, BiographyState> {

    constructor(props: Readonly<{}>) {
        super(props);

        this.state = {
            biographyEntries: []
        };
    }

    componentDidMount() {
        getAllBiographyEntries(getCurrentLangCode()).then(data => {
            this.setState({
                biographyEntries: data
            });
        });
    }

    render() {

        const langData = getLangData();

        return (
            <div className="container">

                <div className="row mb-5">
                    <div className="col">
                        <p className="h1 fw-300">{langData.biography.header}</p>
                    </div>
                </div>

                {this.state.biographyEntries.map((entry, idx, arr) => {
                    return <TimelineEntry
                        idx={idx}
                        bioEntry={entry}
                        arr={arr}
                        key={idx}
                    />;
                })}

            </div>
        );
    }
}
